 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		40: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		40: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"0":"vendors~Assessments~Assignments~AssignmentsModal~Checkout~GoalDetails~KidFrame~KidFrameDetail~Learno~f3ab678b","1":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","2":"vendors~Checkout~KidFrame~LearnosityEduAuthor~MemberHomepage~MyCollections","3":"vendors~Assessments~GoalDetails~KidFrame~MyStudents","4":"Checkout~Pricing~Sellpage","5":"vendors~KidFrame~MemberHomepage~MyCollections","6":"AnonymousHomepage~RelatedGuidedLesson","7":"LandingPage~Pricing","8":"PredefinedCollectionsDetail~SubPlansList","9":"vendors~Assessments~MyStudents","10":"AnonymousHomepage","11":"Assessments","12":"Assignments","13":"AssignmentsModal","14":"BackToSchoolBundle","15":"Checkout","16":"FeaturedArtwork","17":"GoalDetails","18":"GradeFilteredContentCards","19":"KidFrame","20":"KidFrameDetail","21":"LandingPage","22":"LearnosityEduAuthor","23":"MemberHomepage","24":"MyCollections","25":"MyStudents","26":"PracticeSkill","27":"PredefinedCollectionsDetail","28":"Pricing","29":"ProgressTracker","30":"RegistrationModal","31":"RelatedGuidedLesson","32":"Reviews","33":"SeasonalDaysDropdown","34":"Sellpage","35":"SubPlansList","36":"TakeAssessmentModal","37":"vendors~Checkout","38":"vendors~MyStudents","39":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"241c0034663cc183e91a","1":"8c6f349ed923e3683bc0","2":"a4c3173deef6aab4c483","3":"17f3936c5236a5132d99","4":"62b95ea130f753f98e83","5":"8a2aa0e3d9c49521dee7","6":"afb079850999d45c073e","7":"2b66b26b1aa2b44e9415","8":"d5ea1b89d8cd47e6faa0","9":"6d01a92b8825732ca5c1","10":"c8a547edd57bbc72dd91","11":"31f476c92380b805ddc0","12":"c9b52aca88d4c104165a","13":"b238d4c5faf6e81552a9","14":"78c47b384e528138a409","15":"7ceeda12aeee24fd1c00","16":"144014e4f8f756baab76","17":"9c16e9d7b19384274a6a","18":"aa9e3c77929787a58f18","19":"f8f05c8cf6cb21f5b2e3","20":"473f497d5437428616eb","21":"d58e8aff72a2ef44e7e1","22":"88f23056624fe0eddd88","23":"bb34d557ebc5a4fa0f7f","24":"230712c163e88a40c035","25":"22bcb0092fc0915d54e2","26":"6d04c2df9b8daea69895","27":"50d912b134b9b84d9ddd","28":"e57f51778181731a1c49","29":"59d4bbd653fa65590816","30":"29b3d01f1e5e6d6113af","31":"318f301a1f58874de2a7","32":"1fae3aaae476107e5b36","33":"d06651bb4c163962308c","34":"db091fe2f52331b904f8","35":"2f612a747fcee18919cc","36":"36dba8a4b21425c5f1a1","37":"184c0b5e0b0022e85a7e","38":"7949374fac90a34aa7ce","39":"69e730022f015d900919"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"7":1,"11":1,"13":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"22":1,"23":1,"24":1,"25":1,"26":1,"29":1,"30":1,"32":1,"33":1,"34":1,"36":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"0":"vendors~Assessments~Assignments~AssignmentsModal~Checkout~GoalDetails~KidFrame~KidFrameDetail~Learno~f3ab678b","1":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","2":"vendors~Checkout~KidFrame~LearnosityEduAuthor~MemberHomepage~MyCollections","3":"vendors~Assessments~GoalDetails~KidFrame~MyStudents","4":"Checkout~Pricing~Sellpage","5":"vendors~KidFrame~MemberHomepage~MyCollections","6":"AnonymousHomepage~RelatedGuidedLesson","7":"LandingPage~Pricing","8":"PredefinedCollectionsDetail~SubPlansList","9":"vendors~Assessments~MyStudents","10":"AnonymousHomepage","11":"Assessments","12":"Assignments","13":"AssignmentsModal","14":"BackToSchoolBundle","15":"Checkout","16":"FeaturedArtwork","17":"GoalDetails","18":"GradeFilteredContentCards","19":"KidFrame","20":"KidFrameDetail","21":"LandingPage","22":"LearnosityEduAuthor","23":"MemberHomepage","24":"MyCollections","25":"MyStudents","26":"PracticeSkill","27":"PredefinedCollectionsDetail","28":"Pricing","29":"ProgressTracker","30":"RegistrationModal","31":"RelatedGuidedLesson","32":"Reviews","33":"SeasonalDaysDropdown","34":"Sellpage","35":"SubPlansList","36":"TakeAssessmentModal","37":"vendors~Checkout","38":"vendors~MyStudents","39":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"545cf4cc82b0cacef059","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"373d01b133fe1ea7fab2","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"8166c0208172d9c6bf1f","12":"31d6cfe0d16ae931b73c","13":"4fb4ea3fc2a2a5de9b82","14":"31d6cfe0d16ae931b73c","15":"619a8d23aa941f86766b","16":"d56d9288e4c0c7368f48","17":"36d5a28035cd25226f8a","18":"83e0046bc0ea33eabf0e","19":"48eb6ea87f1779b024db","20":"48eb6ea87f1779b024db","21":"31d6cfe0d16ae931b73c","22":"8300fbd3904f23f3370c","23":"c7eaf7210bd47bde2e91","24":"ab19f0324e469dc86f86","25":"fc8137647b75d90140d7","26":"5491656ee574e8b4a49d","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"c34e0607236a0d8b7959","30":"15360b7af750b308abb0","31":"31d6cfe0d16ae931b73c","32":"3eb70bdfce6885905434","33":"eaafc727492eb4363427","34":"e93ab79a6074534761f4","35":"31d6cfe0d16ae931b73c","36":"8d565360e15cbee4219f","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([388,41]);
 	// run deferred modules when ready
 	return checkDeferredModules();
